var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSwap3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07167 8.00009C5.80935 6.72238 6.88601 5.67355 8.1826 4.96956C9.47919 4.26557 10.9452 3.93384 12.4186 4.01106C13.8919 4.08827 15.3152 4.57142 16.5311 5.40708C17.747 6.24275 18.7081 7.39838 19.3082 8.7462M3.23169 5.51546L3.9611 8.67499C4.08534 9.21312 4.62229 9.54866 5.16042 9.42442L8.31996 8.69501M18.9281 16C18.1904 17.2777 17.1138 18.3265 15.8172 19.0305C14.5206 19.7345 13.0546 20.0662 11.5812 19.989C10.1079 19.9118 8.68456 19.4287 7.46866 18.593C6.25276 17.7573 5.29164 16.6017 4.69155 15.2539M20.7681 18.4846L20.0387 15.3251C19.9144 14.787 19.3775 14.4514 18.8394 14.5757L15.6798 15.3051",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSwap3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/swap-3.c9ea76920eee18c906b6681af44ca62a.svg";